import { WHATSAPP_NUMBER } from '../data/site'

export function whatsappUrl(message: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
}

/** Abre WhatsApp en una pestaña nueva; si el navegador lo bloquea, navega en la misma. */
export function openWhatsApp(message: string): void {
  const url = whatsappUrl(message)
  const win = window.open(url, '_blank', 'noopener,noreferrer')
  if (!win) window.location.href = url
}
